import { API_VERSION, CLIENT_VERSION } from './version.js';

// Values prefixed `process.env.*` are replaced at build time by esbuild's
// `define`. At runtime they evaluate to the baked-in string literal.
const env = (typeof process !== 'undefined' && process.env) || {};

export const config = {
  apiUrl: env.SAYERMORE_API_URL || 'http://localhost:8080',
  apiVersion: API_VERSION,
  clientVersion: CLIENT_VERSION,
  clerkKey: env.CLERK_PUBLISHABLE_KEY || '',
  sentryDsn: env.SENTRY_DSN || '',
  dbName: 'sayermore-web',
  dbVersion: 1,
  storeName: 'captures',
  trialDays: 14,
  freeStorageBytes: 1024 * 1024 * 1024,
};
